import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18352 18353"
    {...props}
  >
    <path
      d="M2873 2873c2742 2780 4246 4321 4282 5182-760-204-1937-738-3634-1515 1738 824 2924 1393 3556 1851-430 726-2605 755-6815 786 3897 28 6050 55 6689 635-682 394-1891 848-3638 1499 1812-645 3053-1082 3824-1204 212 817-1306 2375-4264 5373 2780-2743 4321-4246 5181-4282-203 760-738 1937-1515 3634 825-1739 1393-2925 1852-3556 726 430 755 2605 785 6814 29-3897 56-6049 636-6688 393 682 848 1891 1498 3638-645-1813-1081-3053-1203-3824 816-212 2374 1305 5372 4263-2742-2779-4246-4320-4282-5181 761 204 1937 738 3634 1515-1738-825-2924-1393-3555-1851 429-726 2605-755 6814-786-3897-28-6050-56-6689-635 682-394 1891-848 3638-1499-1812 645-3053 1082-3824 1204-211-817 1306-2375 4264-5373-2780 2743-4321 4246-5181 4282 203-760 738-1937 1515-3634-825 1738-1393 2925-1851 3556-726-430-756-2605-786-6815-29 3897-56 6050-636 6689-393-682-848-1891-1498-3638 645 1813 1081 3053 1203 3824-816 212-2374-1305-5372-4264z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 524.345,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
